<div class="roots-table-container mat-elevation-z8">
  <mat-table
    #sort="matSort"
    matSort
    [dataSource]="dataSource"
    style="flex: 1 1 auto;"
    >
    @for (actionCol of actionCols; track actionCol; let i = $index) {
      <ng-container
        matColumnDef="{{ actionCol.name }}"
        >
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ actionCol.name | titlecase }}
        </mat-header-cell>
        <mat-cell *matCellDef="let entity; let e = index">
          @if (actionCol.icon) {
            <!-- If there is a switch present, put its switch values here base on prop name-->
            @if (actionCol.switch) {
              @if (entity[actionCol.switch[0].PROP_name]) {
                <ng-container class="center">
                  <button
                    mat-raised-button
                    color="primary"
                    (click)="switchClicked(actionCol.switch[0], entity)"
                    matTooltip="{{actionCol.switch[0].toolTip}}"
                    >
                    {{actionCol.switch[0].name}}
                  </button>
                </ng-container>
              } @else {
                <button
                  mat-raised-button
                  color="warn"
                  (click)="switchClicked(actionCol.switch[1], entity)"
                  matTooltip="{{actionCol.switch[1].toolTip}}"
                  >
                  {{actionCol.switch[1].name}}
                </button>
              }
            } @else {
              <button
                mat-icon-button
                color="primary"
                (click)="actionClicked(entity, actionCol)"
                matTooltip="{{actionCol.toolTip}}"
                matTooltipPosition="above"
                >
                <mat-icon class="mat-18">{{actionCol.icon}}</mat-icon>
              </button>
            }
          } @else {
            @if (actionCol.textButton === true) {
              <button mat-button
                color="primary"
                (click)="actionClicked(entity, actionCol)"
                matTooltip="{{actionCol.toolTip}}"
                matTooltipPosition="above">
                {{ entity[actionCol.name] }}
              </button>
            } @else {
              {{ entity[actionCol.name] }}
            }
            <!-- {{ entity[actionCol.name] }} -->
          }
        </mat-cell>
      </ng-container>
    }

    <mat-header-row *matHeaderRowDef="actionNameList"></mat-header-row>
    <mat-row
      *matRowDef="let row; columns: actionNameList"
      matRipple
      class="example-element-row"
      (click)="addDataToCustomDataSet(row)"
      >
    </mat-row>
  </mat-table>

  <mat-paginator #paginator [pageSize]="20" [pageSizeOptions]="[1, 2, 3, 5, 10, 20]" showFirstLastButtons>
  </mat-paginator>
</div>